import React from "react";
import { Link } from "react-router";
import Helmet from "react-helmet";
import { Row, Col, Card } from "antd";
import News from "./news";
import { PUBLIC_URL, API_URL } from "../../config";
import CaseCountsDonutChart from "./case-count-chart";
import BarChartPatents from "./bar-chart-patents";
import BarChartOPEN from "./bar-chart-open";
import BarChartOPAL from "./bar-chart-opal";
import Logo from "../common/logo";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  cardContent: {
    width: "100%",
    height: 338,
    overflow: "auto",
    padding: 0
  }
};

const queriesPTAB = [
  ["Pending", { up_status: "Pending", sort: "-filing_date" }],
  ["Not Ins", { up_status: "Not Instituted", sort: "-filing_date" }],
  ["FWD", { up_status: "Terminated", up_substatus: "Final Written Decision", sort: "-filing_date" }],
  ["Settled", { up_status: "Terminated", up_substatus: "Settlement", sort: "-filing_date" }],
  ["Adverse", { up_status: "Terminated", up_substatus: "Adverse Judgment", sort: "-filing_date" }],
  ["Procedural", { up_status: "Terminated", up_substatus: "Procedural Termination", sort: "-filing_date" }]
];

const queriesLitigation = [
  ["District", { flag: "DC", sort: "-filed_date" }],
  ["Supreme", { flag: "SC", sort: "-filed_date" }],
  ["Circuit", { flag: "CAFC", sort: "-filed_date" }],
  ["ITC", { flag: "ITC", sort: "-filed_date" }],
  ["CFC", { flag: "CFC", sort: "-filed_date" }]
];

const Home = () => {
  const helmet = {
    title: "Portal",
    meta: [
      {
        name: "keywords",
        content: "unified patents portal,PTAB,litigation,PTAB portal,PTAB search,PTAB database,litigation search,litigation database,examiner"
      },
      {
        name: "description",
        content: "Search all PTAB and litigation case dockets, AI-powered patents research and analytics."
      }
    ],
    link: [
      {
        rel: "canonical",
        href: PUBLIC_URL
      }
    ]
  };
  const linkUnifiedDockets = (
    <Link
      to={{
        pathname: "/ptab/caselist",
        query: {
          petitioners: "Unified Patents",
          sort: "-filing_date"
        }
      }}
    >
      {
        <span>
          Filed by <Logo size="20px" style={{ position: "relative", top: 5 }} />
          {" Unified Patents"}
        </span>
      }
    </Link>
  );
  const linkNpeCases = (
    <Link
      to={{
        pathname: "/litigation/caselist",
        query: {
          entity_type: ["NPE (Individual)", "NPE (Small Company)", "NPE (Patent Assertion Entity)"]
        }
      }}
    >
      {"NPE Cases"}
    </Link>
  );
  const linkOPAL = (
    <Link to="/standards/opal/hevc">
      <span><b>O</b>bjective <b>PA</b>tent <b>L</b>andscape</span>
    </Link>
  )
  const linkOPEN = (
    <Link to="/standards/open/mpeg">
      Standards Submission Database
    </Link>
  )
  return (
    <div style={styles.body}>
      <Helmet {...helmet} />
      <Row gutter={16}>
        <Col lg={8} span={24}>
          <Card title="PTAB" bodyStyle={styles.cardContent} extra={linkUnifiedDockets}>
            <CaseCountsDonutChart
              queries={queriesPTAB}
              api="ptab"
              path="/ptab/caselist"
              legends={queriesPTAB.map(q => q[0])}
              scrollable={false}
              arcValueFormat={val => val.toLocaleString()}
              exportable={false}
            />
          </Card>
        </Col>
        <Col lg={8} span={24}>
          <Card title="LITIGATION" bodyStyle={styles.cardContent} extra={linkNpeCases}>
            <CaseCountsDonutChart
              queries={queriesLitigation}
              api="litigation"
              path="/litigation/caselist"
              legends={queriesLitigation.map(q => q[0])}
              scrollable={false}
              arcValueFormat={val => val.toLocaleString()}
              exportable={false}
            />
          </Card>
        </Col>
        <Col lg={8} span={24}>
          <Card title="News" bodyStyle={styles.cardContent}>
            <News />
          </Card>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col lg={8} span={24}>
          <BarChartOPAL
            options={[
              { value: "hevc_v4", label: "HEVC" },
              { value: "avc_v1", label: "AVC" },
              { value: "lte_v3", label: "LTE" },
              { value: "5g_v2", label: "5G" }
            ]}
            esUrlBase={API_URL}
            field={"assignee_parent"}
            flag={"OPAL"}
            extra={linkOPAL}
          />
        </Col>
        <Col lg={8} span={24}>
          <BarChartOPEN
            options={[
              { value: "jctvc", label: "HEVC" },
              { value: "jvt", label: "AVC" },
              { value: "3gpp_lte", label: "LTE" },
              { value: "3gpp_5g", label: "5G" },
              { value: "ieee80211", label: "IEEE" },
              { value: "ietf", label: "IETF" }
            ]}
            esUrlBase={API_URL}
            field={"source"}
            flag={"OPEN"}
            extra={linkOPEN}
          />
        </Col>
        <Col lg={8} span={24}>
          <BarChartPatents
            options={[
              { value: "number", label: "Granted" },
              { value: "pvix_sum", label: "PVIX" },
              { value: "annuities", label: "Annuities" }
            ]}
            field={"assignee_parent"}
            flag={"PATENTS"}
            extra={<Link to={{ pathname: "/patents/search" }}>See All Patents</Link>}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
